import { faro } from "@grafana/faro-react";
import { useEffect } from "react";
import { ViewName } from "../views";
import { isClientInitialized, shouldFaroBeEnabled } from "./initialize";

type FaroMeta = {
  viewName: ViewName;
};

export function setMetadata(meta: FaroMeta) {
  if (!isClientInitialized(faro)) {
    console.warn("Faro has not been initialized. Skipping setting metadata.");
    return;
  }
  const view = faro.api.getView();
  if (meta.viewName !== view?.name) {
    faro.api.setView({ name: meta.viewName });
  }
}

export function useSetMetaData(meta: FaroMeta) {
  useEffect(() => {
    if (shouldFaroBeEnabled()) {
      setMetadata(meta);
    }
  }, [meta]);
}
